import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconCloudCog,
  IconTrendingUp,
  IconShield,
  IconCoin,
} from '@tabler/icons-react';

const teleworkingFeatures: FeatureData[] = [
  {
    title: 'features.teleworking.title',
    description: 'features.teleworking.description',
    icon: <IconCloudCog size={24} />,
    key: 'features.teleworking'
  },
  {
    title: 'features.growingCompanies.title',
    description: 'features.growingCompanies.description',
    icon: <IconTrendingUp size={24} />,
    key: 'features.growingCompanies'
  },
  {
    title: 'features.ciso.title',
    description: 'features.ciso.description',
    icon: <IconShield size={24} />,
    key: 'features.ciso'
  },
  {
    title: 'features.cfo.title',
    description: 'features.cfo.description',
    icon: <IconCoin size={24} />,
    key: 'features.cfo'
  },
];

export default teleworkingFeatures; 